module.exports = __webpack_public_path__ + "218434093e3279841060f0b92429514d.png";